/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Pit2_TInputs */

const en_to_csv_pit2_t = /** @type {(inputs: To_Csv_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nested data becomes a string, not columns`)
};

const ko_to_csv_pit2_t = /** @type {(inputs: To_Csv_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 데이터는 열이 아니라 문자열이 됩니다`)
};

const ja_to_csv_pit2_t = /** @type {(inputs: To_Csv_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたデータは列ではなく文字列になります`)
};

/**
* | output |
* | --- |
* | "Nested data becomes a string, not columns" |
*
* @param {To_Csv_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_pit2_t = /** @type {((inputs?: To_Csv_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_pit2_t(inputs)
	if (locale === "ko") return ko_to_csv_pit2_t(inputs)
	return ja_to_csv_pit2_t(inputs)
});